/**
 * Footer Component
 * Site-wide footer with links and information
 */

import { Link } from 'react-router-dom'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'

// Version info - update this when deploying
const APP_VERSION = '1.5.0'
const BUILD_DATE = '2026-01-01'

export const Footer = () => {
  const currentYear = new Date().getFullYear()
  const { flags } = useFeatureFlags()

  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* About */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-3">About</h3>
            <p className="text-sm text-gray-600">
              Paiseh! helps you create and share wishlists{flags.enableSecretSanta && ', organize gift exchanges, and coordinate Secret Santa events'} with ease.
            </p>
          </div>

          {/* Product */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-3">Product</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/wishlists" className="text-sm text-gray-600 hover:text-blue-600">
                  My Wishlists
                </Link>
              </li>
              <li>
                <Link to="/reservations" className="text-sm text-gray-600 hover:text-blue-600">
                  My Reservations
                </Link>
              </li>
              {flags.enableSecretSanta && (
                <li>
                  <Link to="/secret-santa" className="text-sm text-gray-600 hover:text-blue-600">
                    Secret Santa
                  </Link>
                </li>
              )}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-3">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" className="text-sm text-gray-600 hover:text-blue-600">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-sm text-gray-600 hover:text-blue-600">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/cookies" className="text-sm text-gray-600 hover:text-blue-600">
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-3">Support</h3>
            <ul className="space-y-2">
              {/* <li>
                <Link to="/" className="text-sm text-gray-600 hover:text-blue-600">
                  Help Center
                </Link>
              </li> */}
              <li>
                <a
                  href="mailto:liu.kwn@gmail.com?subject=[Paiseh.sg]%20Support"
                  className="text-sm text-gray-600 hover:text-blue-600"
                >
                  Contact Us
                </a>
              </li>
              <li>
                <a
                  href="mailto:liu.kwn@gmail.com?subject=[Paiseh.sg]%20Feedback"
                  className="text-sm text-gray-600 hover:text-blue-600"
                >
                  Send Feedback
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-600">
              © {currentYear} Paiseh! All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <p className="text-sm text-gray-500">
                Made with ❤️ in Singapore
              </p>
              <p className="text-xs text-gray-400">
                v{APP_VERSION} ({BUILD_DATE})
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
